<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <label tag="div">Código</label>
            <b-form-input type="text"
                         placeholder="Código"
                         v-model="form.cd"
                         name="cd">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

            <b-form-text>Descrição</b-form-text>
            <b-form-input type="text"
                          placeholder="Descrição"
                          v-model="form.descr"
                          name="descr">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

            <b-form-text>Tag</b-form-text>
            <b-form-input type="text"
                          placeholder="Tag"
                          v-model="form.tag"
                          name="tag">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('tag')" v-if="form.errors.has('tag')"></b-form-feedback>

            <b-form-text>Registro</b-form-text>
            <b-form-input type="text"
                          placeholder="Registro"
                          v-model="form.registro"
                          name="registro">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('registro')" v-if="form.errors.has('registro')"></b-form-feedback>

            <b-form-text>Ordem</b-form-text>
            <b-form-input type="text"
                          placeholder="Ordem"
                          v-model="form.ordem"
                          name="ordem">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('ordem')" v-if="form.errors.has('ordem')"></b-form-feedback>

            <b-form-text>Tipo Grupo</b-form-text>
            <multiselect v-model="tpGrupoSelected"
            :options="optionsLivTpGrupo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('tp_grupo')" v-if="form.errors.has('tp_grupo')"></b-form-feedback>

            <b-form-text>Grupo Dados</b-form-text>
            <multiselect v-model="grupoDadosSelected"
            :options="optionsGrupoDados"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('grupo_dados')" v-if="form.errors.has('grupo_dados')"></b-form-feedback>

            <b-form-text>Grupo Layout</b-form-text>
            <multiselect v-model="grupoLayoutSelected"
            :options="optionsGrupoLayout"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('layout_grupo')" v-if="form.errors.has('layout_grupo')"></b-form-feedback>

            <b-form-text>Status</b-form-text>
            <multiselect v-model="statusSelected"
            :options="optionsLivStatus"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>

        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      statusSelected: [],
      tpGrupoSelected: [],
      grupoDadosSelected: [],
      grupoLayoutSelected: [],
      optionsLivStatus: [],
      optionsLivTpGrupo: [],
      optionsGrupoDados: [],
      optionsGrupoLayout: [],
      form: new Form({   cd: '',
                        descr: '',
                        tag: '',
                        registro: '',
                        ordem: '',
                        laygrp_id_pai: '',
                        lay_id: '',
                        tp_grupo: '',
                        bgrpdad_id: '',
                        status: '',
                        laygrp_id: ''
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    tpGrupoSelected(obj) {
        this.form.tp_grupo = obj.value;
    },
    grupoDadosSelected(obj) {
        this.form.bgrpdad_id = obj.value;
    },
    grupoLayoutSelected(obj) {
        this.form.laygrp_id_pai = obj.value;
    }
},
mounted() {
    this.getLivGeral();
},
created() {
    let self = this;
    Event.$on('editGrupo', function (data) {
        self.onEdit(data);
    });
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.laygrp_id);
        }
    },
    onCreate (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.statusSelected = [];
      this.grupoDadosSelected = [];
      this.grupoLayoutSelected = [];
      this.tpGrupoSelected = [];
      this.form.reset();
      this.form.lay_id = data.lay_id;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.statusSelected = [];
      this.grupoDadosSelected = [];
      this.grupoLayoutSelected = [];
      this.tpGrupoSelected = [];
      this.form.reset();
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.tag = data.tag;
      this.form.registro = data.registro;
      this.form.registro = data.registro;
      this.form.ordem = data.ordem;
      this.statusSelected = {label: data.status.descr, value: data.status.valor};
      if(data.b_grupo_dados!==null)
      {
          this.grupoDadosSelected = {label: data.b_grupo_dados.descr, value: data.b_grupo_dados.bgrpdad_id};
      }
      if(data.layout_grupo!==null)
      {
          this.grupoLayoutSelected = {label: data.layout_grupo.descr, value: data.layout_grupo.laygrp_id};
      }
      this.tpGrupoSelected = {label: data.tp_grupo.descr, value: data.tp_grupo.valor};
      this.form.laygrp_id = data.laygrp_id;
      this.form.lay_id = data.lay_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/layoutgrupo/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
            })
            response.tp_grupo.forEach((obj)=>
            {
                this.optionsLivTpGrupo.push({ label: obj.descr, value: obj.valor })
            })
            response.grupo_dados.forEach((obj)=>
            {
                this.optionsGrupoDados.push({ label: obj.descr, value: obj.bgrpdad_id })
            })
            response.grupo_layout.forEach((obj)=>
            {
                this.optionsGrupoLayout.push({ label: obj.descr, value: obj.laygrp_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
